import { useCallback, useEffect, useState } from "react";

import { useResponsive } from "../../../../../../../hooks/useResponsive";

export function useDetailDescriptionState({
  accessToUpdate,
  cardDescription,
  description,
  handleDescriptionSave,
  isfocus,
  toggleChatbotVisibility,
}) {
  const [text, setText] = useState(description);
  const isMobile = useResponsive("down", "md");
  const isUnder321 = useResponsive("down", "400");

  useEffect(() => {
    setText(description);
  }, [description]);

  const handleWandClick = useCallback(() => {
    toggleChatbotVisibility();
  }, [toggleChatbotVisibility]);

  const handleCancel = useCallback(() => {
    setText(description);
    if (accessToUpdate) {
      cardDescription.set(description);
    }
  }, [accessToUpdate, cardDescription, description]);

  const handleEditorChange = useCallback(
    (content) => {
      if (!accessToUpdate) {
        return;
      }

      cardDescription.set(content);
      setText(content);
    },
    [accessToUpdate, cardDescription]
  );

  const handleBlur = useCallback(
    (content) => {
      if (accessToUpdate) {
        cardDescription.set(content);
        setText(content);
      }

      isfocus(false);

      setTimeout(() => {
        if (accessToUpdate) {
          handleDescriptionSave(content);
        }
      }, 300);
    },
    [accessToUpdate, cardDescription, handleDescriptionSave, isfocus]
  );

  const handleSave = useCallback(() => {
    handleDescriptionSave(text);
  }, [handleDescriptionSave, text]);

  return {
    handleBlur,
    handleCancel,
    handleEditorChange,
    handleSave,
    handleWandClick,
    isMobile,
    isUnder321,
    onFocus: () => accessToUpdate,
    text,
  };
}
